import { useLocation } from 'react-router-dom';
import { useRouteRef } from '@backstage/core-plugin-api';
import { createTechdocsReaderPageRef } from '../routes';
import { LEGACY_DOCS_ENTITY_REF } from '../utils/docCategory';
import { getLegacyPagePath } from '../utils/legacyDocsNav';

/**
 * The URL of the legacy Aura docs site, and the path of the open page inside
 * it. `pagePath` is `undefined` on every page outside the site.
 */
export function useLegacyDocsLocation(): {
  basePath: string;
  pagePath: string | undefined;
} {
  const { pathname } = useLocation();
  const getReaderPath = useRouteRef(createTechdocsReaderPageRef);
  const basePath = getReaderPath(LEGACY_DOCS_ENTITY_REF);

  return { basePath, pagePath: getLegacyPagePath(pathname, basePath) };
}
